export const PACKAGE_NAME = 'jira-software-ec-client';

export const MutationType = {
	Create: 'Create',
	Update: 'Update',
	Delete: 'Delete',
} as const;
export type MutationType = (typeof MutationType)[keyof typeof MutationType];
